module.exports = __webpack_public_path__ + "static/vf_wouter_core.d95c2e82.svg";